module.exports = __webpack_public_path__ + "static/media/647JettStNW_2018-06-26_132.79631c08.jpg";